import theme from "../gatsby-plugin-theme-ui/index"

export default {
    NotificationItem: { // Override the notification item
      DefaultStyle: { // Applied to every notification, regardless of the notification level
        padding: theme.space[5],
        borderRadius: theme.radii[2],
        WebkitBoxShadow: '0 3px 12px rgba(0,0,0,0.2)',
        MozBoxShadow: '0 3px 12px rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.2)'
      },
  
      success: { // Applied only to the success notification item
        borderTop: 0,
        backgroundColor: 'white',
        color: theme.colors.black
      },

      error: {
        borderTop: 0,
        backgroundColor: 'white',
        color: theme.colors.black
      },

      warning: {
        borderTop: 0,
        backgroundColor: 'white',
        color: theme.colors.black
      },

      info: {
        borderTop: 0,
        backgroundColor: 'white',
        color: theme.colors.black
      },
    },
    Title: {
      success: {
        color: theme.colors.black
      },
  
      error: {
        color: theme.colors.black
      },
  
      warning: {
        color: theme.colors.black
      },
  
      info: {
        color: theme.colors.black
      }
    },

    Dismiss: {
      DefaultStyle: {
        cursor: 'pointer',
        fontFamily: 'Arial',
        fontSize: '24px',
        position: 'absolute',
        top: '12px',
        right: '10px',
        lineHeight: '1.2rem',
        color: 'rgba(0,0,0,0.4)',
        backgroundColor: 'transparent',
        borderRadius: '50%',
        width: '1.2rem',
        height: '1.2rem',
        fontWeight: 'bold',
        textAlign: 'center'
      },
  
    },

    Action: {
      DefaultStyle: {
        borderRadius: '40px',
      },
  
      success: {
        backgroundColor: theme.colors.secondaryColor,
        color: '#ffffff'
      },
  
      error: {
        backgroundColor: theme.colors.primaryColor,
        color: '#ffffff'
      },
  
      warning: {
        backgroundColor: theme.colors.primaryColor,
        color: '#ffffff'
      },
  
      info: {
        backgroundColor: theme.colors.neutral600,
        color: '#ffffff'
      }
    },
  }